import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import VoiceCallAgentIntegrations from '../../VoiceCallAgentIntegrations/components/VoiceCallAgentIntegrations';
import PosIntegration from '../components/Pos/PosIntegration';

const Integrations = lazy(() => import('../components/Integrations'));

const SocialMediaIntegration = lazy(
  () => import('../../SocialMediaIntegration/components/SocialMediaIntegration')
);
const NotificationConfigurations = lazy(
  () => import('../../NotificationConfigurations/components/NotificationConfigurations')
);
const NotificationConfigOld = lazy(
  () => import('../../Channels/components/Channels')
);

const VoiceCallIntegrations = lazy(
  () => import('../../VoiceCallIntegrations/components/VoiceCallIntegrations')
);

const integrationRoute: RouteObject = {
  path: '/settings/integrations',
  element: <Integrations />,
  children: [
    {
      index: true,
      element: <Navigate to='./channel' replace />,
    },
    {
      path: 'channel',
      element: <NotificationConfigurations />,
    },
    {
      path: 'channel-old',
      element: <NotificationConfigOld />,
    },
    {
      path: 'voice-call',
      element: <VoiceCallIntegrations />,
    },
    {
      path: 'voice-call-agent',
      element: <VoiceCallAgentIntegrations />,
    },
    {
      path: 'social-media',
      element: <SocialMediaIntegration />,
    },
    {
      path: 'pos',
      element: <PosIntegration />,
    },
  ],
};

export default integrationRoute;
